import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-mi-send-invoice',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './dialog-mi-send-invoice.component.html',
  styleUrl: './dialog-mi-send-invoice.component.scss',
})
export class DialogMiSendInvoiceComponent {
  readonly data = inject<{ emailAddress: string }>(MAT_DIALOG_DATA);
}
